<template>
  <div
    v-if="messageRepied"
    class="rounded d-flex align-items-center">
    <img
      class="rounded align-self-center"
      :src="this.thumb"
      style="width: 33px; height: 33px; object-fit: cover" />
    <div class="ms-2">[Video]</div>
  </div>

  <div v-else>
    <video
      id="myVideo"
      ref="video"
      style="object-fit: contain; min-height: 250px; max-width: 400px; min-width: 400px; height: auto"
      controls
      :poster="this.thumb">
      <source
        :src="this.href"
        type="video/mp4" />
    </video>
    <div
      v-if="title"
      class="ms-2">
      {{ title }}
    </div>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";

export default {
  name: "ChatVideo",
  props: ["href", "thumb", "messageRepied", "title"],
  methods: {
    getPlayerOptions() {
      return {
        muted: true,
        controls: true,
        sources: [
          {
            type: "video/mp4",
            src: this.href,
          },
        ],
        poster: this.thumb,
        height: 400,
        width: 400,
      };
    },
    rewind() {
      var myVideo = document.getElementById("myVideo");
      myVideo.currentTime = myVideo.currentTime - 5;
    },
    fastForward() {
      var myVideo = document.getElementById("myVideo");
      myVideo.currentTime = myVideo.currentTime + 5;
    },
    addKeyEvent(event) {
      switch (event.keyCode) {
        case 37: // left arrow
          this.rewind();
          break;
        case 39: // right arrow
          this.fastForward();
          break;
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.addKeyEvent);
  },
};
</script>

<style scoped>
</style>